import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN, USER_KEY } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import AuthService from 'services/AuthService';
import { Modal, Button } from 'antd';
import React from 'react';
import parse from 'html-react-parser';
import ManageLocalStorage from 'utils/local-storage';
import { jwtDecode } from 'jwt-decode'; // import dependency

const notificationArticle = () => {
    const listModules = ['FOB_Supplier', 'FOB_Article']; // List of modules
    let arrEntity = [];
    listModules.forEach((elm) => {
        let entity = ManageLocalStorage.get(elm, 'entities');
        console.log('entity', entity);
        if (entity != null)
            entity.forEach((e) => {
                arrEntity.push(e);
            });
    });
    let html = "<ul style='list-style: circle;'>";
    if (arrEntity) {
        arrEntity.forEach((element) => {
            console.log('element', element.info);
            if (element.info.id !== '')
                html += `<li><a href='${element.info.url}/${element.info.id}/?tabId=${element.info.tabId}' target='_blank' >${element.info['desc']}  <b>Xử lý</b></a> </li>`;
            else
                html += `<li><a href='${element.info.url}?tabId=${element.info.tabId}' target='_blank' >${element.info['desc']}  <b>Xử lý</b></a> </li>`;
        });
        html += '</ul>';
    }
    Modal.info({
        title: 'Thông báo về công việc đang chưa xử lý.',

        width: 520,
        content: <div>{parse(html)}</div>,
        footer: (
            <div style={{ float: 'right' }}>
                <Button type="text" href={`/app/apps/notification/notification-list/`}>
                    Xem tất cả
                </Button>
                <Button type="text" href={`/app`}>
                    Thoát
                </Button>
            </div>
        ),
        // onOk() {},
    });
};

export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN) || null,
    updateProfile: 1,
    resetCaptcha: false
};

export const signIn = createAsyncThunk('auth/signIn', async (data, { rejectWithValue }) => {
    try {
        // const response = await FirebaseService.signInEmailRequest(email, password)
        // console.log('data form:', data);
        const response = await AuthService.login(data);

        // console.log('res', response);
        if (response?.data?.accessToken) {
            const token = response?.data?.accessToken;
            localStorage.setItem(AUTH_TOKEN, token);
            localStorage.setItem(
                USER_KEY,
                JSON.stringify({
                    id: response?.data?.user?.id,
                    avatar: response?.data?.user?.avatar,
                    name: response?.data?.user?.name,
                    username: response?.data?.user?.username,
                    email: response?.data?.user?.email,
                    employee_code: response?.data?.user?.employee_code,
                    department_id: response?.data?.user?.department_id ?? 7,
                    complete_name: response?.data?.user?.complete_name ?? '1.4.KDQT',
                    permissions: response?.data?.permissions
                }),
            );
            return token;
        } else {
            // return rejectWithValue(response.message?.replace('Firebase: ', ''));
            return rejectWithValue('Xác thực không đúng yêu cầu đăng nhập lại');
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});

export const signUp = createAsyncThunk('auth/signUp', async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
        const response = await FirebaseService.signUpEmailRequest(email, password);
        if (response.user) {
            const token = response.user.refreshToken;
            localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
            return token;
        } else {
            return rejectWithValue(response.message?.replace('Firebase: ', ''));
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});

export const signOut = createAsyncThunk('auth/signOut', async () => {
    //const response = await FirebaseService.signOutRequest();
    const response = await AuthService.logout();
    localStorage.removeItem(AUTH_TOKEN);
    ManageLocalStorage.clear_search();
    localStorage.removeItem(USER_KEY);
    return null;
});

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInGoogleRequest();
    if (response.user) {
        const token = response.user.refreshToken;
        localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
        return token;
    } else {
        return rejectWithValue(response.message?.replace('Firebase: ', ''));
    }
});

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInFacebookRequest();
    if (response.user) {
        const token = response.user.refreshToken;

        localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
        return token;
    } else {
        return rejectWithValue(response.message?.replace('Firebase: ', ''));
    }
});

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authenticated: (state, action) => {
            state.loading = false;
            state.redirect = '/';
            state.token = action.payload;
        },
        showAuthMessage: (state, action) => {
            state.message = action.payload;
            state.showMessage = true;
            state.loading = false;
        },
        hideAuthMessage: (state) => {
            state.message = '';
            state.showMessage = false;
        },
        signOutSuccess: (state) => {
            state.loading = false;
            state.token = null;
            state.redirect = '/';
        },
        showLoading: (state) => {
            state.loading = true;
        },
        signInSuccess: (state, action) => {
            state.loading = false;
            state.token = action.payload;
        },
        updateProfile: (state, action) => {
            localStorage.setItem(
				USER_KEY,
				JSON.stringify({
                    id: action.payload.id,
					avatar: action.payload.avatar,
					name: action.payload.name,
					username: action.payload.username,
					email: action.payload.email,
					employee_code: action.payload.employee_code,
					permissions: action.payload.permissions
				}),
			);
            state.updateProfile = state.updateProfile === undefined || state.updateProfile === null ? 1 : state.updateProfile + 1
        },
        confirmResetCaptcha: (state) => {
            state.resetCaptcha = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true;
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.loading = false;
                const listModules = ['FOB_Supplier', 'FOB_Article']; // List of modules
                let arrEntity = [];
                listModules.forEach((elm) => {
                    let entity = ManageLocalStorage.get(elm, 'entities');
                    if (entity != null)
                        entity.forEach((e) => {
                            arrEntity.push(e);
                        });
                });
                if (arrEntity.length > 0) {
                    // call modal notice - list article in localstorage
                    notificationArticle();
                }
                state.redirect = '/';
                state.token = action.payload;
            })
            .addCase(signIn.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
                state.resetCaptcha = true;
            })
            .addCase(signOut.fulfilled, (state) => {
                state.loading = false;
                state.token = null;
                state.redirect = '/';
            })
            .addCase(signOut.rejected, (state) => {
                state.loading = false;
                state.token = null;
                state.redirect = '/';
            })
            .addCase(signUp.pending, (state) => {
                state.loading = true;
            })
            .addCase(signUp.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = '/';
                state.token = action.payload;
            })
            .addCase(signUp.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signInWithGoogle.pending, (state) => {
                state.loading = true;
            })
            .addCase(signInWithGoogle.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = '/';
                state.token = action.payload;
            })
            .addCase(signInWithGoogle.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(signInWithFacebook.pending, (state) => {
                state.loading = true;
            })
            .addCase(signInWithFacebook.fulfilled, (state, action) => {
                state.loading = false;
                state.redirect = '/';
                state.token = action.payload;
            })
            .addCase(signInWithFacebook.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            });
    },
});

export const { authenticated, showAuthMessage, hideAuthMessage, confirmResetCaptcha, signOutSuccess, showLoading, signInSuccess, updateProfile } =
    authSlice.actions;

export default authSlice.reducer;
